import { Component } from '@angular/core';
import { LoadingScreenService } from './loading-screen.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule]
    
})
export class LoadingScreenComponent {
  constructor(public loadingScreenService: LoadingScreenService) {}
}